import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL || "https://tspm-api.abrandfantastic.workers.dev";
const SITE_URL = "https://houseoflollipop.com";

const DEFAULTS = {
  lol_headline:           "Should Lollipop make a come back?",
  lol_subtext:            "It once meant something.\nI'm thinking about bringing it back\nbut only if you want me to.",
  lol_video:              "",
  lol_video_badge:        "LOLLIPOP",
  lol_video_caption:      "DJ Mon on the ones and twos",
  lol_submit_btn:         "Yes. Bring it Back",
  lol_privacy_note:       "No spam. Just updates if Lollipop returns.",
  lol_ty_headline:        "One more step",
  lol_ty_subtext:         "We've sent a confirmation email to your inbox.\nClick the link inside to secure your spot.",
  lol_ty_message:         "No confirmation, no spot.\nCheck your inbox — it should be there now.",
  lol_confirmed_headline: "You're on the list",
  lol_confirmed_subtext:  "If Lollipop comes back, you'll be the first to know.",
  lol_confirmed_message:  "Lollipop was more than a t-shirt label.\nIt was a statement. A feeling. A moment in time.\nMaybe it's time for another moment.",
};

const WAITLIST_FIELDS = [
  { key: "lol_headline",      label: "Headline",      hint: 'e.g. "Should Lollipop make a come back?"' },
  { key: "lol_subtext",       label: "Subtext",       hint: "Paragraph below the headline", multiline: true },
  { key: "lol_video_badge",   label: "Video badge",   hint: 'Label tag on the video card e.g. "LOLLIPOP"' },
  { key: "lol_video_caption", label: "Video caption", hint: 'Caption below the video e.g. "DJ Mon on the ones and twos"' },
  { key: "lol_submit_btn",    label: "Button text",   hint: 'e.g. "Yes. Bring it Back"' },
  { key: "lol_privacy_note",  label: "Privacy note",  hint: 'Small text below the button e.g. "No spam. Just updates if Lollipop returns."' },
];

const THANKYOU_FIELDS = [
  { key: "lol_ty_headline", label: "Headline",     hint: 'e.g. "One more step"' },
  { key: "lol_ty_subtext",  label: "Subtext",      hint: "Shown below the headline — prompt to check inbox", multiline: true },
  { key: "lol_ty_message",  label: "Message card", hint: "Text inside the grey message card", multiline: true },
];

const CONFIRM_FIELDS = [
  { key: "lol_confirmed_headline", label: "Headline",     hint: 'e.g. "You\'re on the list" — {name} is appended automatically' },
  { key: "lol_confirmed_subtext",  label: "Subtext",      hint: "Shown below the headline after confirmation", multiline: true },
  { key: "lol_confirmed_message",  label: "Message card", hint: "Text inside the message card on the confirm page", multiline: true },
];

function Tab({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
        active ? "border-black text-black" : "border-transparent text-gray-400 hover:text-gray-700"
      }`}
    >
      {label}
    </button>
  );
}

export default function PopWaitlist() {
  const [content, setContent]   = useState(DEFAULTS);
  const [draft, setDraft]       = useState(DEFAULTS);
  const [saving, setSaving]     = useState({});
  const [uploading, setUploading] = useState(false);
  const [flash, setFlash]       = useState(null);
  const [tab, setTab]           = useState("waitlist");
  const videoRef = useRef(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/site-content`)
      .then(({ data }) => {
        const merged = { ...DEFAULTS };
        Object.keys(DEFAULTS).forEach(k => { if (data[k] !== undefined) merged[k] = data[k]; });
        setContent(merged);
        setDraft(merged);
      })
      .catch(() => {});
  }, []);

  async function saveKey(key, value) {
    setSaving(s => ({ ...s, [key]: true }));
    try {
      await axios.put(`${API_URL}/api/site-content`, { [key]: value });
      setContent(c => ({ ...c, [key]: value }));
      showFlash("Saved ✓", "green");
    } catch {
      showFlash("Save failed", "red");
    } finally {
      setSaving(s => ({ ...s, [key]: false }));
    }
  }

  async function uploadVideo(file) {
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("key", "lol_video");
      const { data } = await axios.post(`${API_URL}/api/site-content/images`, formData);
      setContent(c => ({ ...c, lol_video: data.url }));
      setDraft(d => ({ ...d, lol_video: data.url }));
      if (videoRef.current) videoRef.current.value = "";
      showFlash("Video uploaded ✓", "green");
    } catch {
      showFlash("Upload failed", "red");
    } finally {
      setUploading(false);
    }
  }

  function showFlash(msg, colour) {
    setFlash({ msg, colour });
    setTimeout(() => setFlash(null), 2500);
  }

  const isDirty = key => draft[key] !== content[key];

  const renderFields = (fields) => (
    <div className="space-y-4">
      {fields.map(({ key, label, hint, multiline }) => (
        <div key={key}>
          <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
          {multiline ? (
            <textarea
              rows={3}
              value={draft[key] ?? ""}
              onChange={e => setDraft(d => ({ ...d, [key]: e.target.value }))}
              className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-gray-500 resize-y"
            />
          ) : (
            <input
              type="text"
              value={draft[key] ?? ""}
              onChange={e => setDraft(d => ({ ...d, [key]: e.target.value }))}
              className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-gray-500"
            />
          )}
          {hint && <p className="text-xs text-gray-400 mt-0.5">{hint}</p>}
          {isDirty(key) && (
            <button
              onClick={() => saveKey(key, draft[key])}
              disabled={saving[key]}
              className="mt-1.5 text-xs bg-black text-white px-3 py-1 rounded hover:bg-gray-800 disabled:opacity-50"
            >
              {saving[key] ? "Saving…" : "Save"}
            </button>
          )}
        </div>
      ))}
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto px-6 py-8 space-y-6">

      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-xl font-bold text-gray-900">Pop Waitlist</h1>
          <p className="text-sm text-gray-500 mt-0.5">Manage the House of Lollipop waitlist page content.</p>
        </div>
        <a href={SITE_URL} target="_blank" rel="noopener noreferrer"
          className="text-xs border border-gray-300 px-3 py-1.5 rounded hover:bg-gray-50 whitespace-nowrap">
          VIEW SITE →
        </a>
      </div>

      {flash && (
        <div className={`text-sm px-4 py-2 rounded font-medium ${
          flash.colour === "green" ? "bg-green-50 text-green-700 border border-green-200" :
          "bg-red-50 text-red-600 border border-red-200"
        }`}>
          {flash.msg}
        </div>
      )}

      <div className="border-b border-gray-200 flex gap-0 -mb-2">
        <Tab label="Waitlist Page"  active={tab === "waitlist"}  onClick={() => setTab("waitlist")} />
        <Tab label="Thank You Page" active={tab === "thankyou"}  onClick={() => setTab("thankyou")} />
        <Tab label="Confirm Page"   active={tab === "confirm"}   onClick={() => setTab("confirm")} />
      </div>

      {tab === "waitlist" && (
        <div className="space-y-8 pt-2">
          <section>
            <h2 className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-4">Video</h2>
            <div className="flex items-start gap-4">
              {content.lol_video
                ? <video src={content.lol_video} className="w-28 h-36 object-cover border border-gray-200 rounded" muted />
                : <div className="w-28 h-36 bg-gray-100 border border-dashed border-gray-300 rounded flex items-center justify-center text-xs text-gray-400">No video</div>
              }
              <div>
                <button onClick={() => videoRef.current?.click()} disabled={uploading}
                  className="text-xs border border-gray-300 px-3 py-1.5 rounded hover:bg-gray-50 disabled:opacity-50">
                  {uploading ? "Uploading…" : content.lol_video ? "Replace video" : "Upload video"}
                </button>
                <p className="text-xs text-gray-400 mt-1.5">
                  Portrait 4:5 video (e.g. 1080×1350px) — it's cropped to fill the frame, so avoid landscape clips.
                  MP4, under ~15MB recommended for fast loading. Plays muted &amp; looped, so keep it short (5–15s).
                </p>
                <input ref={videoRef} type="file" accept="video/*" className="hidden"
                  onChange={e => e.target.files[0] && uploadVideo(e.target.files[0])} />
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-4">Page Content</h2>
            {renderFields(WAITLIST_FIELDS)}
          </section>
        </div>
      )}

      {tab === "thankyou" && (
        <div className="space-y-8 pt-2">
          <section>
            <h2 className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-1">Thank You Page</h2>
            <p className="text-xs text-gray-400 mb-4">Shown immediately after signup — asks the user to check their email.</p>
            {renderFields(THANKYOU_FIELDS)}
          </section>
        </div>
      )}

      {tab === "confirm" && (
        <div className="space-y-8 pt-2">
          <section>
            <h2 className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-1">Confirmation Page</h2>
            <p className="text-xs text-gray-400 mb-4">Shown after the user clicks the confirmation link in their email.</p>
            {renderFields(CONFIRM_FIELDS)}
          </section>
        </div>
      )}

    </div>
  );
}
